import { queryKeys } from '@/lib/query-keys';
import { checkoutClient } from '@/lib/api/ts-rest';
import type {
  Checkout,
} from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';


export const useCheckout = (
  organizationId: string | undefined,
  options: { enabled?: boolean } = {},
) => {
  const { enabled = true } = options;
  return useQuery<Checkout | null, Error>({
    queryKey: queryKeys.checkout.detail(organizationId),
    queryFn: async () => {
      const res = await checkoutClient.getCheckout({
        query: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load checkout');
      return res.body;
    },
    enabled: !!organizationId && enabled,
  });
};

export const useCheckoutItemCount = (organizationId: string | undefined) => {
  return useQuery<number, Error>({
    queryKey: queryKeys.checkout.count(organizationId),
    queryFn: async () => {
      const res = await checkoutClient.getCheckoutItemCount({
        query: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load count');
      return res.body.count;
    },
    enabled: !!organizationId,
  });
};
